import { ICustomProperties, IEventTelemetry } from "@microsoft/applicationinsights-web";
import { PowerBiReport } from "powerbi-reports/models";

export class OpenPowerBiReportEvent implements IEventTelemetry {
    name: string = "OpenPowerBiReportEvent";
    report: PowerBiReport;

    constructor(powerBiReport: PowerBiReport) {
        this.report = powerBiReport;
    }

    public getCustomProperties = (): ICustomProperties => {
        return {
            id: this.report.id,
            name: this.report.name,
            embedUrl: this.report.embedUrl,
            datasetId: this.report.datasetId,
            webUrl: this.report.webUrl
        };
    };
}
